<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-4/usecase-07'" :width="500" :height="745" />

        </div>
        <div class="spacing center">

            <div>

                <h2>Immersive voice for more engaging augmented and virtual reality gaming</h2>

                <p>Offer a more immersive experience in augmented and virtual reality games by implementing crystal clear voice conversations between gamers.</p>

                <a href="https://www.nokia.com/networks/solutions/voice-over-5g-vo5g-core/#5g-ecosystem" class="button" target="_blank">Discover the usecase</a>

            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>